var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticClass:"mt-10"},[_c('v-card-title',{staticClass:"text-break"},[_vm._v(" Editer le dossier ")]),_c('FormFolder',{attrs:{"editedFolder":_vm.editedFolder,"idFolder":_vm.idFolder}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }